import { CorrespondenceType } from "../../types/correspondence/correspondencePermissions"
import { CorrespondenceEntityType } from "toptaal-shared"

export const correspondenceQueryKeys = {
  all: ["correspondence"] as const,

  inbox: () => [...correspondenceQueryKeys.all, "inbox"] as const,

  archivedInbox: () =>
    [...correspondenceQueryKeys.all, "archived", "inbox"] as const,

  participants: (
    entityId: number,
    entityType: CorrespondenceEntityType,
    type: CorrespondenceType,
  ) =>
    [
      ...correspondenceQueryKeys.all,
      "participants",
      entityType,
      entityId,
      type,
    ] as const,

  entity: (entityType: CorrespondenceEntityType, entityId: number) =>
    [...correspondenceQueryKeys.inbox(), entityType, entityId] as const,

  messages: (
    threadId: number,
    entityId?: number,
    entityType?: CorrespondenceEntityType,
  ) =>
    [
      ...correspondenceQueryKeys.all,
      "messages",
      entityId,
      entityType,
      threadId,
    ] as const,

  thread: (
    entityType: CorrespondenceEntityType,
    entityId: number | null,
    threadId: number,
  ) =>
    [...correspondenceQueryKeys.all, entityType, entityId, threadId] as const,

  student: (
    studentId: number,
    entityType: CorrespondenceEntityType = "Student",
  ) => correspondenceQueryKeys.entity(entityType, studentId),

  studentThread: (
    studentId: number,
    threadId: number,
    entityType: CorrespondenceEntityType = "Student",
  ) => correspondenceQueryKeys.thread(entityType, studentId, threadId),

  group: (
    groupId: number,
    entityType: CorrespondenceEntityType = "LessonGroup",
  ) => correspondenceQueryKeys.entity(entityType, groupId),

  groupThread: (
    groupId: number,
    threadId: number,
    entityType: CorrespondenceEntityType = "LessonGroup",
  ) => correspondenceQueryKeys.thread(entityType, groupId, threadId),

  project: (
    projectId: number,
    entityType: CorrespondenceEntityType = "Project",
  ) => correspondenceQueryKeys.entity(entityType, projectId),

  projectThread: (
    projectId: number,
    threadId: number,
    entityType: CorrespondenceEntityType = "Project",
  ) => correspondenceQueryKeys.thread(entityType, projectId, threadId),

  unreadCount: () => [...correspondenceQueryKeys.all, "unreadCount"] as const,
}
